import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-creditor-details',
  templateUrl: './app-creditor-details.component.html'
})
export class AppCreditorDetailsComponent {

  /**
   * The formData that is being passed between each sub-component which
   * will eventually be posted to the remote service.
   */
  @Input()
  formData: any;

  /**
   * The Event emitter used to keep track of any changes to the number of
   * creditors that should be in the formData array.
   * @type {EventEmitter<number>}
   */
  @Output()
  updateCreditorCount: EventEmitter<number> = new EventEmitter<number>();

  /**
   * The add creditor function fires the event emitter to increase the
   * current number of creditors by one.
   */
  public addCreditor(): void {
    this.updateCreditorCount.emit(this.formData.creditors.length + 1);
  }
  public checkValue(value: string | number): boolean {
    return Number(value) > 0;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/creditor-details/app-creditor-details.component.ts